export default {
    // Header Section
    "discover_your": "जानें अपना",
    "numerology": "अंक ज्योतिष",
    "numbers_reveal_destiny": "संख्या आपके भाग्य का रहस्य खोलती हैं",
    "numerology_description": "अंक ज्योतिष के माध्यम से अपने जीवन में अंकों की रहस्यमयी शक्ति को जानें। अपने जीवन पथ, भाग्यांक, व्यक्तित्व गुण और दिव्य संख्यात्मक प्रभावों का व्यापक विश्लेषण प्राप्त करें।",

    // Service Information
    "enter_details_for_numerology": "अंक ज्योतिष के लिए अपनी जानकारी भरें",
    "complete_numerology_analysis": "पूर्ण अंक ज्योतिष विश्लेषण",
    "service_price": "सेवा शुल्क",
    "comprehensive_numerology_analysis_note": "अपने संख्यात्मक खाके की गहराई से जांच करें और अपने जीवन के दिव्य गणितीय पैटर्न जानें",

    // Form Fields
    "full_name": "पूरा नाम",
    "enter_full_name": "अपना पूरा नाम दर्ज करें",
    "name_vibration_analysis": "आपका नाम विशेष संख्यात्मक तरंगें वहन करता है जो आपके भाग्य को प्रभावित करती हैं",
    "email_address": "ईमेल पता",
    "enter_email_address": "अपना ईमेल पता दर्ज करें",
    "phone_number": "फोन नंबर",
    "enter_phone_number": "अपना फोन नंबर दर्ज करें",
    "gender": "लिंग",
    "male": "पुरुष",
    "female": "महिला",
    "other": "अन्य",
    "date_of_birth": "जन्म तिथि",
    "birth_date_life_path_number": "आपकी जन्म तिथि आपके जीवन पथ अंक और मुख्य जीवन उद्देश्य का खुलासा करती है",
    "preferred_language": "पसंदीदा भाषा",
    "english": "अंग्रेज़ी",
    "hindi": "हिंदी",
    "telugu": "तेलुगु",
    "kannada": "कन्नड़",
    "language_note": "आपका अंक ज्योतिष विश्लेषण चुनी गई भाषा में दिया जाएगा",

    // Core Numerology Features
    "life_path_number_analysis": "जीवन पथ अंक विश्लेषण",
    "destiny_number_insights": "भाग्यांक विश्लेषण",
    "personality_number_traits": "व्यक्तित्व अंक के गुण",
    "lucky_numbers_and_colors": "शुभ अंक और रंग",
    "career_compatibility_numbers": "करियर अनुकूलता अंक",
    "pdf_download": "पूर्ण पीडीएफ रिपोर्ट",

    "what_you_get": "आपको क्या मिलेगा",
    "complete_numerology_chart": "पूर्ण अंक ज्योतिष चार्ट",
    "core_numbers_analysis": "मुख्य अंकों का विश्लेषण",
    "personal_year_predictions": "वार्षिक भविष्यवाणी",
    "compatibility_insights": "अनुकूलता मार्गदर्शन",

    // Actions & Buttons
    "pay_and_generate_analysis": "मेरा अंक ज्योतिष विश्लेषण प्राप्त करें",
    "processing_payment": "भुगतान संसाधित हो रहा है",
    "processing_request": "विश्लेषण तैयार हो रहा है",

    // Payment & Success Messages
    "thank_you": "धन्यवाद",
    "payment_successful": "भुगतान सफल!",
    "numerology_analysis_processing": "हमारे विशेषज्ञ अंक ज्योतिषी आपका विश्लेषण तैयार कर रहे हैं। आपको अपने संख्यात्मक खाके की विस्तृत जानकारी मिलेगी।",
    "order_id": "ऑर्डर आईडी",
    "payment_id": "भुगतान आईडी",
    "amount_paid": "भुगतान राशि",

    // Delivery Information
    "delivery_information": "वितरण जानकारी",
    "delivery_time": "विश्लेषण वितरण समय",
    "within_12_hours_delivery_note": "आपकी रिपोर्ट 12 घंटों के भीतर तैयार हो जाएगी",
    "whatsapp_notification": "व्हाट्सऐप अपडेट",
    "whatsapp_delivery_note": "व्हाट्सऐप पर तुरंत सूचनाएं प्राप्त करें",
    "email_delivery": "ईमेल वितरण",
    "email_delivery_note": "पूर्ण विश्लेषण भेजा जाएगा",

    // What You'll Receive
    "what_youll_receive": "आपको जो पैकेज मिलेगा",
    "detailed_numerology_report": "विस्तृत अंक ज्योतिष रिपोर्ट (PDF)",
    "life_path_destiny_analysis": "जीवन पथ और भाग्यांक विश्लेषण",
    "personal_numbers_meanings": "व्यक्तिगत अंकों का महत्व",
    "lucky_elements_guidance": "शुभ तत्व मार्गदर्शन",
    "annual_forecast_insights": "वार्षिक अंक ज्योतिष पूर्वानुमान",

    // Visual Content
    "sample_numerology_analysis": "नमूना अंक ज्योतिष विश्लेषण",
    "life_path_number": "जीवन पथ अंक",
    "sample_life_path_description": "साधक - विश्लेषणात्मक, आध्यात्मिक और आत्मचिंतनशील स्वभाव",
    "sample_numerology_description": "आपके व्यक्तिगत विश्लेषण का पूर्वावलोकन",
    "core_numbers": "मुख्य अंक",

    // Core Number Types
    "life_path": "जीवन पथ",
    "destiny": "भाग्य",
    "personality": "व्यक्तित्व",
    "soul_urge": "आत्मा की प्रेरणा",
    "birthday": "जन्मदिन",
    "maturity": "परिपक्वता",

    // Status & Processing
    "your_numerology_analysis_status": "आपके विश्लेषण की स्थिति",
    "processing_your_analysis": "आपके अंक गणना हो रही है",
    "analysis_processing_message": "हमारे विशेषज्ञ आपके अंकों का विश्लेषण कर रहे हैं और रिपोर्ट तैयार कर रहे हैं।",
    "request_id": "विश्लेषण आईडी",
    "status": "स्थिति",
    "processing": "प्रगति पर",
    "pending": "लंबित",
    "email_notification_sent": "ईमेल पुष्टिकरण भेजा गया",
    "whatsapp_update_coming": "व्हाट्सऐप अपडेट सक्रिय",
    "delivery_within_12_hours": "12 घंटे में रिपोर्ट तैयार",

    // Support & Contact
    "contact_support": "अंक ज्योतिष सहायता से संपर्क करें",
    "need_help": "मार्गदर्शन चाहिए?",
    "contact_us_at": "हमसे संपर्क करें",

    // Error Messages
    "please_fill_all_required_fields": "कृपया सभी आवश्यक विवरण भरें",
    "payment_failed": "भुगतान असफल। कृपया पुनः प्रयास करें।",
    "processing_failed": "विश्लेषण विफल। कृपया सहायता टीम से संपर्क करें।",

    // Core Numerology Numbers
    "life_path_number": "जीवन पथ अंक",
    "destiny_number": "भाग्यांक",
    "personality_number": "व्यक्तित्व अंक",
    "soul_urge_number": "आत्मा प्रेरणा अंक",
    "birthday_number": "जन्मदिन अंक",
    "maturity_number": "परिपक्वता अंक",
    "expression_number": "अभिव्यक्ति अंक",
    "heart_desire_number": "हृदय की इच्छा अंक",

    // Number Meanings (1-9)
    "number_1_meaning": "नेतृत्व, स्वतंत्रता, अग्रणी",
    "number_2_meaning": "सहयोग, साझेदारी, कूटनीति",
    "number_3_meaning": "रचनात्मकता, अभिव्यक्ति, संचार",
    "number_4_meaning": "स्थिरता, कड़ी मेहनत, आधार",
    "number_5_meaning": "स्वतंत्रता, रोमांच, परिवर्तन",
    "number_6_meaning": "पालन-पोषण, ज़िम्मेदारी, उपचार",
    "number_7_meaning": "आध्यात्मिकता, विश्लेषण, ज्ञान",
    "number_8_meaning": "भौतिक सफलता, अधिकार, उपलब्धि",
    "number_9_meaning": "मानवतावादी, पूर्णता, सेवा",

    // Master Numbers
    "master_number_11": "मास्टर नंबर 11 - अंतर्ज्ञान और प्रेरणा",
    "master_number_22": "मास्टर नंबर 22 - महान निर्माता",
    "master_number_33": "मास्टर नंबर 33 - महान शिक्षक",

    // Personality & Character Analysis
    "core_personality_traits": "मुख्य व्यक्तित्व गुण",
    "strengths_and_talents": "प्राकृतिक ताकतें और प्रतिभाएं",
    "challenges_to_overcome": "पार करने योग्य चुनौतियां",
    "life_lessons": "मुख्य जीवन पाठ",
    "inner_motivation": "आंतरिक प्रेरणाएं",
    "outer_expression": "दूसरे आपको कैसे देखते हैं",

    // Life Path Analysis
    "life_purpose": "जीवन उद्देश्य और मिशन",
    "career_guidance": "करियर मार्गदर्शन",
    "relationship_patterns": "संबंध पैटर्न",
    "financial_tendencies": "पैसा और वित्तीय प्रवृत्तियां",
    "health_insights": "स्वास्थ्य और कल्याण अंतर्दृष्टि",
    "spiritual_journey": "आध्यात्मिक यात्रा",

    // Compatibility Analysis
    "love_compatibility": "प्रेम जीवन",
    "friendship_compatibility": "मित्रता अनुकूलता",
    "business_compatibility": "व्यावसायिक साझेदारी अनुकूलता",
    "family_dynamics": "पारिवारिक संबंध",
    "compatible_numbers": "सबसे अनुकूल अंक",
    "challenging_numbers": "संभावित चुनौतीपूर्ण अंक",

    // Lucky Elements
    "lucky_numbers": "व्यक्तिगत शुभ अंक",
    "lucky_colors": "शुभ रंग",
    "lucky_days": "शुभ दिन",
    "lucky_gemstones": "लाभदायक रत्न",
    "lucky_directions": "शुभ दिशाएं",
    "lucky_metals": "शुभ धातुएं",

    // Personal Year Analysis
    "current_personal_year": "वर्तमान व्यक्तिगत वर्ष",
    "personal_year_theme": "वर्ष की थीम और फोकस",
    "monthly_guidance": "मासिक मार्गदर्शन",
    "opportunities_this_year": "मुख्य अवसर",
    "challenges_this_year": "संभावित चुनौतियां",
    "recommendations_this_year": "विशेष अनुशंसाएं",

    // Name Analysis
    "name_numerology": "नाम का अंक ज्योतिष विश्लेषण",
    "first_name_vibration": "पहले नाम की तरंग",
    "last_name_influence": "उपनाम का प्रभाव",
    "full_name_power": "पूरा नाम की शक्ति",
    "nickname_effects": "उपनाम के प्रभाव",
    "name_change_suggestions": "नाम सुधार सुझाव",

    // Birth Date Analysis
    "birth_date_significance": "जन्म तिथि का महत्व",
    "day_vibration": "दिन का प्रभाव",
    "month_influence": "जन्म माह का प्रभाव",
    "year_energy": "जन्म वर्ष की ऊर्जा",
    "complete_birth_pattern": "पूर्ण जन्म पैटर्न विश्लेषण",

    // Karmic Numbers
    "karmic_debt_numbers": "कर्म ऋण अंक",
    "karmic_lessons": "कर्म संबंधी जीवन पाठ",
    "soul_contracts": "आत्मिक अनुबंध",
    "past_life_influences": "पिछले जन्म के प्रभाव",

    // Cycles & Periods
    "life_cycles": "मुख्य जीवन चक्र",
    "pinnacle_numbers": "चरम अवधि अंक",
    "challenge_numbers": "चुनौती अंक",
    "personal_months": "व्यक्तिगत मासिक चक्र",

    // Advanced Analysis
    "master_numbers_significance": "आपके चार्ट में मास्टर नंबर का महत्व",
    "missing_numbers": "लापता अंक विश्लेषण",
    "repeated_numbers": "दोहराए गए अंकों का महत्व",
    "intensity_table": "संख्यात्मक तीव्रता विश्लेषण",

    // Practical Applications
    "best_dates_for_decisions": "महत्वपूर्ण निर्णयों के लिए श्रेष्ठ तिथियां",
    "timing_for_ventures": "नए कार्यों के लिए श्रेष्ठ समय",
    "home_address_analysis": "घर के पते का अंक ज्योतिष",
    "phone_number_analysis": "फोन नंबर की तरंग",
    "choosing_baby_names": "शिशु नाम चुनने का मार्गदर्शन",

    // Remedies & Recommendations
    "numerical_remedies": "अंक ज्योतिष उपाय",
    "color_therapy": "रंग चिकित्सा",
    "gemstone_suggestions": "रत्न सुझाव",
    "mantras_for_numbers": "अंकों के मंत्र",
    "meditation_techniques": "संख्यात्मक ध्यान विधियां",

    // Business & Career
    "business_name_analysis": "व्यवसाय नाम अंक ज्योतिष",
    "career_number_alignment": "करियर-अंक संरेखण",
    "partnership_numbers": "व्यावसायिक साझेदारी अंक",
    "investment_timing": "निवेश समय मार्गदर्शन",
    "product_launch_dates": "उत्पाद लॉन्च तिथि चयन"
};
